module.exports = __webpack_public_path__ + "img/dashboard-users-member.8eca7724.png";